"use client";
import NetworkAddToWallet from "src/components/shared/NetworkAddToWallet";

function Footer() {
  return (
    <div className="footer-wrapper">
      <ogpu-footer />
      <div style={{ paddingBottom: "2rem", background: "#050b18" }}>
        <div className="container footer-section-top-wrapper ">
          <NetworkAddToWallet />
        </div>
      </div>
    </div>
  );
}

export default Footer;
